import {
  MinusOutlined,
  PlusOutlined,
  VerticalLeftOutlined,
  VerticalRightOutlined,
} from "@ant-design/icons";
import { Button, Carousel, Image } from "antd";
import React from "react";
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from "react-zoom-pan-pinch";

const styleDefault = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "40px 20px",
  backgroundColor: "#f9f9f9",
  borderRight: "1px solid #ddd",
  minHeight: "80vh",
  justifyContent: "center",
};

const styleSmall = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "0px",
  backgroundColor: "#f9f9f9",
  borderRight: "1px solid #ddd",
  justifyContent: "center",
};

const ShowImageISMS = ({
  currentIndex,
  setCurrentIndex,
  listBinaryImage,
  undraw_security,
  typeSize,
  messagePage,
}) => {

  return (
    <div
      // @ts-ignore
      style={typeSize === "large" ? styleDefault : styleSmall}
    >
      {listBinaryImage.length > 0 ? (
        <>
          <div
            style={{
              position: "relative",
              border: "1px solid #ddd",
              borderRadius: 12,
              padding: 16,
              backgroundColor: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              width: "100%",
              maxWidth: "100%",
              height: "68vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <TransformWrapper>
              {({ zoomIn, zoomOut, resetTransform }) => (
                <>
                  <TransformComponent
                    contentStyle={{
                      cursor: "zoom-in",
                      width: "100%",
                      display: "flex",
                      padding: "1% 1% 1%",
                      height: "70vh",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* Your content to be zoomed goes here */}
                    <img
                      src={`data:image/png;base64,${listBinaryImage[currentIndex]?.binary_image}`}
                      style={{
                        width: "inherit",
                        maxHeight: "70vh",
                        imageRendering: "unset",
                      }}
                       alt={`Câu hỏi ${currentIndex + 1}`}
                    />
                  </TransformComponent>
                </>
              )}
            </TransformWrapper>

            {/* <img
              src={`data:image/png;base64,${listBinaryImage[currentIndex]?.binary_image}`}
              alt={`Câu hỏi ${currentIndex + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: 8,
              }}
            /> */}

            {/* Nút Trước */}
            <Button
              onClick={() => setCurrentIndex((prev) => Math.max(prev - 1, 0))}
              disabled={currentIndex === 0}
              style={{
                left: 10,
              }}
              className="custom-next-btn"
            >
              <VerticalRightOutlined style={{ fontSize: "20px" }} />
            </Button>

            {/* Nút Tiếp */}
            <Button
              onClick={() =>
                setCurrentIndex((prev) =>
                  Math.min(prev + 1, listBinaryImage.length - 1)
                )
              }
              disabled={currentIndex === listBinaryImage.length - 1}
              style={{
                right: 10,
              }}
              className="custom-next-btn"
            >
              <VerticalLeftOutlined style={{ fontSize: "20px" }} />
            </Button>
          </div>

          <div style={{ marginTop: 20, fontSize: 16, fontWeight: 500 }}>
            Trang {currentIndex + 1}/{listBinaryImage.length}
          </div>
        </>
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "40px 20px",
          }}
        >
          <img
            src={undraw_security}
            alt="Security illustration"
            style={{
              width: 300,
              maxWidth: "100%",
              marginBottom: 20,
              opacity: 0.8,
            }}
          />
          <div
            style={{
              fontSize: 16,
              fontStyle: "italic",
              color: "#888",
            }}
          >
            {messagePage}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShowImageISMS;
